<script lang="ts">
    import { onMount } from 'svelte'
    import { viewedAthlete } from '../PredictiveMode/predictive'
    // A way into the plan status report from the Program tab: a plan in progress, and a new feature, so it says so.
    export let href = '/plan-report/current'
    // A coach looking at an athlete's Program tab opens that athlete's status, not their own.
    onMount(async () => {
        const athlete = await viewedAthlete()
        if (athlete) href = `${href}?forUser=${encodeURIComponent(athlete)}`
    })
</script>

<a {href} class="plan-status-banner group flex items-center gap-4 border border-solid rounded border-xerteal-600/40 bg-gradient-to-r from-xerteal-600/10 to-xerteal-600/5 px-5 py-4 no-underline hover:border-xerteal-600/70 transition-colors">
    <i class="fa-regular fa-chart-line text-2xl text-xerteal-700 shrink-0" aria-hidden="true"/>
    <div class="flex flex-col gap-0.5 min-w-0">
        <div class="flex items-center gap-2 flex-wrap">
            <span class="font-bold text-lg text-slate-800">Plan status</span>
            <span class="rounded-full bg-xerteal-700 text-white text-[11px] font-semibold uppercase tracking-wide px-2 py-0.5">New</span>
        </div>
        <span class="text-slate-600 text-sm">See how your plan is going: your fitness so far, the training you have completed and where your plan is heading.</span>
    </div>
    <span class="ml-auto shrink-0 text-xerteal-700 font-semibold whitespace-nowrap group-hover:underline">View status <i class="fa-regular fa-arrow-right ml-1" aria-hidden="true"/></span>
</a>
